import axios from "axios";

export const environment = {
  Local: "Local",
  Test: "Test",
};

export const URLType = {
  Test: process.env.REACT_APP_API_URL,
};

export default axios.create({
  baseURL: URLType.Test,
  environment: environment.Test,
});
